import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {
  static createGuid(): string {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  static getDeepValue(source, field): any {
    field = field.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    field = field.replace(/^\./, ''); // strip a leading dot
    const path = field.split('.');
    for (let i = 0, n = path.length; i < n; ++i) {
      const partName = path[i];
      if (source && partName in source) {
        source = source[partName];
      } else {
        return;
      }
    }
    return source;
  }

  static isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  /**
   * Get the current year
   */
  public getYear(): number {
    return new Date().getFullYear();
  }
}
